export const MANAGERS_TYPE_KEY = "d-managers-type";
export const ROLES_KEY = "d-roles";
